<ul class="button-menu">
  <li routerLinkActive="active" class="list-menu dropDownHeader">
    <a class="disabled-ref" (click)="trackMenuClick($event, 'notifications email / sms', 'menu')"> <!-- EasyTrack: KPI 1 -->
      <mat-icon>mail_outline</mat-icon>
      <span>Notifications Email / SMS</span>
    </a>
    <div routerLinkActive="active" class="dropDownHeaderContent">
      <a routerLink="/dashboard" (click)="trackMenuClick($event, 'tableau de bord', 'menu - email')"> <!-- EasyTrack: KPI 1 -->
        <img src="/assets/images/bar-chart.svg" alt="bar chart icon">
        <span>Tableau de bord</span>
      </a>
    </div>
    <div routerLinkActive="active" class="dropDownHeaderContent">
      <a routerLink="/notifications/email-sms" (click)="trackMenuClick($event, 'detail des notifications', 'menu - email')"> <!-- EasyTrack: KPI 1 -->
        <mat-icon>lightbulb_outline</mat-icon>
        <span>Détail des notifications</span>
      </a>
    </div>
    @if (thresholdsVisible) {
      <div routerLinkActive="active" class="dropDownHeaderContent">
        <a routerLink="/alerting/thresholds" (click)="trackMenuClick($event, 'alertes sur mes emails', 'menu - email')"> <!-- EasyTrack: KPI 1 -->
          <img src="/assets/images/notification.svg" alt="notification icon">
          <span>Alertes sur mes emails</span>
        </a>
      </div>
    }
  </li>
  <li routerLinkActive="active" class="list-menu dropDownHeader">
    <a class="disabled-ref" (click)="trackMenuClick($event, 'notifications teams', 'menu')"> <!-- EasyTrack: KPI 13 -->
      <span>Notifications Teams</span>
    </a>
    <div routerLinkActive="active" class="dropDownHeaderContent">
      <a routerLink="/notifications/teams" (click)="trackMenuClick($event, 'detail des notifications', 'menu - teams')"> <!-- EasyTrack: KPI 13 -->
        <mat-icon>lightbulb_outline</mat-icon>
        <span>Détail des notifications</span>
      </a>
    </div>
    @if (teamsCampaignVisible) {
      <div routerLinkActive="active" class="dropDownHeaderContent">
          <a routerLink="/teams/campaign" (click)="trackMenuClick($event, 'campagnes teams', 'menu - teams')"> <!-- EasyTrack: KPI 13 -->
          <img class="icon" src="/assets/images/edit-square.svg" alt="send notification icon">
          <span>Campagnes Teams</span>
        </a>
      </div>
    }
  </li>
</ul>
